import { PAGE_HEADER_HEIGHT } from '@/catalog-apps/components/config'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/shadcn/breadcrumb'
import { IconRightChevronOutline } from '@icons/IconRightChevronOutline'
import { Link } from 'react-router'
import { useCurrentApplication } from './useCurrentApplication'
import { ApplicationIcon } from '@/const'

export function ApplicationsBreadcrumb({
  title,
  breadcrumbLink,
}: {
  title: string
  breadcrumbLink?: {
    label: string
    page: string
  }
}) {
  const { appName, appKey } = useCurrentApplication()
  return (
    <div
      style={{ height: PAGE_HEADER_HEIGHT }}
      className="bg-offwhite/80 sticky top-0 z-20 flex w-full items-center justify-between gap-10 border-b py-2 backdrop-blur"
    >
      <Breadcrumb className="backdrop-blur">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link className="hover:text-primary hover:underline" to="/applications">
                Applications
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <IconRightChevronOutline />
          </BreadcrumbSeparator>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link className="flex items-center hover:text-primary hover:underline" to={`/applications/${appKey}`}>
                <ApplicationIcon className="mr-2" /> {appName}
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <IconRightChevronOutline />
          </BreadcrumbSeparator>
          {breadcrumbLink && (
            <>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link
                    className="flex items-center hover:text-primary hover:underline"
                    to={`/applications/${appKey}/${breadcrumbLink.page}`}
                  >
                    {breadcrumbLink.label}
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator>
                <IconRightChevronOutline />
              </BreadcrumbSeparator>
            </>
          )}
          <BreadcrumbItem>
            <BreadcrumbPage>{title}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  )
}
